import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-24754_educator_journey_updates'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
